import {call, put, select} from 'redux-saga/effects';
import {ISkeletonSaga, skeletonSaga} from '../../apis/skeleton/skeletonSaga';
import {GENERIC_ERROR} from '../../constants/ErrorConstants';
import {GET_PLAYERS_SUCCESS} from '../../constants/PlayerConstants';
import {GetSnapshotPlayersCall} from "../../apis/snapshot";
import {EventPlayerStoredObjects, EventsStoredObjects} from "../../@types/response";
import {getFixtures} from "../../store/selectors/getFixtures";

function* tryFunction() {
    const response: EventPlayerStoredObjects[] = yield call(GetSnapshotPlayersCall);
    const fixtures: EventsStoredObjects = yield select(getFixtures);
    const merged = response.map((e: EventPlayerStoredObjects) => ({...fixtures[e.eventId], ...e}));
    yield put({
        type: GET_PLAYERS_SUCCESS,
        payload: merged
    });
}

export function* getPlayersSaga(): Generator {
    const sagaPayload: ISkeletonSaga = {
        tryApiCall: {function: tryFunction},
        failedType: GENERIC_ERROR
    };
    yield call(skeletonSaga, sagaPayload);
}